<template>
  <div class="layout">
    <div class="frame">
      <input-email />
      <input-password />
      <input-save-email-pass />
      <button-login />
    </div>
  </div>
</template>

<script>
import InputEmail from './InputEmail'
import InputPassword from './InputPassword'
import InputSaveEmailPass from './InputSaveEmailPass'
import ButtonLogin from './ButtonLogin'

export default {
  components: {
    InputEmail,
    InputPassword,
    InputSaveEmailPass,
    ButtonLogin
  }
}
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  justify-content: center;
}

.frame {
  max-width: 350px;
  height: 300px;
}
</style>
